// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const SectionBlockContract = contract({
  name: "SectionBlock",
  description: "The top-level container for a marketing page section — hero, feature row, pricing table, testimonial strip, FAQ section. Always reach for SectionBlock over a hand-rolled `<section>` so vertical rhythm, container width, and tonal background stay consistent across the page. Pair `background=\"gradient\"` + `surface=\"glass\"` inner Cards for the \"modern marketing hero\" pattern.",
  import: "@gradeui/ui",
  aliases: ["section","section block","hero section","marketing section","page section","content section","container section","feature section","hero","page hero","marketing hero","glass section","gradient section","mesh hero"],
  composesWith: ["Card (the most common child — especially with surface=\"glass\")","Grid (feature rows)","Stack (hero column)","MediaSurface (hero imagery)","Code (developer hero)","Carousel (logo strips)"],
  styleDefaults: {"SectionBlock":"relative w-full py-16 md:py-24 bg-transparent"},
  variantDefaults: {"padding":"lg","background":"transparent"},
  props: {
  "padding": {
      schema: z.enum(["none", "sm", "md", "lg", "xl"]).optional(),
      design: "knob",
      description: "vertical rhythm. Defaults to `lg`.",
  },
  "background": {
      schema: z.enum(["transparent", "muted", "card", "primary", "gradient"]).optional(),
      design: "knob",
      description: "tonal direction of the section bg.",
  },
  "surface": {
      schema: z.enum(["solid", "translucent", "glass", "glass-strong"]).optional(),
      design: "knob",
      description: "what the section is *made of*. Orthogonal to `background`. Use `glass` for hero sections that float over a generative backdrop / image / dot grid.",
  },
  "container": {
      schema: z.enum(["default", "wide", "narrow", "full"]).optional(),
      design: "knob",
      description: "max-width of the inner content.",
  },
  "alignment": {
      schema: z.enum(["left", "center", "right"]).optional(),
      design: "knob",
      description: "header / CTA alignment.",
  },
  "titleSize": {
      schema: z.enum(["sm", "md", "lg", "xl"]).optional(),
      design: "knob",
  },
  "title": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  "subtitle": {
      schema: z.string().optional(),
      design: "content",
  },
  "cta1": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "string or `{ text, variant, href, onClick }` config",
  },
  "cta2": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "string or `{ text, variant, href, onClick }` config",
  },
  "backgroundImage": {
      schema: z.string().optional(),
      design: "content",
      description: "direct CSS background image url",
  },
  "as": {
      schema: z.enum(["section", "div", "article"]).optional(),
      design: "knob",
      description: "semantic root",
  },
  "fullBleed": {
      schema: z.boolean().optional(),
      design: "knob",
  },
  },
});
